import React, { useMemo } from 'react'
import { extractCookie } from 'lib/web/cookieUtils'
import { EmptyObject } from 'lib/object/objectUtils'

interface CookiesContextValue {
  getCookie: (name: string) => string | undefined
}

const getCookieNoop = () => undefined

/**
 * Isomorphic way for components to get cookies, so any conditional rendering based on cookies values
 * will work on the server as well as the client.
 */
export const CookiesContext = React.createContext<CookiesContextValue>({ getCookie: getCookieNoop })

interface Props {
  /** Only needs to be supplied on the server */
  cookies?: { [name: string]: string | undefined }
}

export function CookiesContextProvider({ cookies = EmptyObject, children }: React.PropsWithChildren<Props>) {
  const value = useMemo(() => {
    const getCookie = typeof document !== 'undefined' ?
        (name: string) => extractCookie(document.cookie, name) :
        (name: string) => cookies[name]

    return { getCookie }
  }, [cookies])

  return <CookiesContext value={value}>
    {children}
  </CookiesContext>
}

export default CookiesContext
